import { useMemo, type ReactNode } from "react";
import {
  scatterChartSpec,
  type ScatterChartSpecOptions,
} from "../specs/scatter.js";
import type { ChartData } from "../types.js";
import { VegaChart } from "./VegaChart.js";
import type { ChartContainerProps } from "./shared.js";

export interface ScatterChartProps
  extends ScatterChartSpecOptions, ChartContainerProps {
  data: ChartData;
}

/** A themed scatter / bubble chart. Pass `size` for bubbles, `color` for groups. */
export function ScatterChart({
  data,
  x,
  y,
  xType,
  yType,
  color,
  colorType,
  size,
  sizeType,
  xTitle,
  yTitle,
  title,
  subtitle,
  ...container
}: ScatterChartProps): ReactNode {
  const spec = useMemo(
    () =>
      scatterChartSpec({
        data,
        x,
        y,
        xType,
        yType,
        color,
        colorType,
        size,
        sizeType,
        xTitle,
        yTitle,
        title,
        subtitle,
      }),
    [
      data,
      x,
      y,
      xType,
      yType,
      color,
      colorType,
      size,
      sizeType,
      xTitle,
      yTitle,
      title,
      subtitle,
    ],
  );

  return <VegaChart spec={spec} {...container} />;
}
